/**
 * Offset do header fixo + margem para scroll spy, scroll programático e scroll-margin dos headings.
 * Manter alinhado entre RichText, TOC e `scrollToHeading`.
 */
export const TOC_HEADER_OFFSET_PX = 100
